<template>
  <div>
    <div class="common-form">编辑技师</div>
    <el-form ref="form" label-width="80px">
      <el-form-item label="真实姓名">
        <el-input class="max-w460" v-model="getdata.username"></el-input>
      </el-form-item>
      <el-form-item label="技师头衔">
        <!-- <el-input class="max-w460" v-model="getdata.label_id"></el-input> -->
        <el-select class="max-w460" v-model="getdata.label_id" placeholder="请选择技师头衔" style="width: 100%;">
          <el-option v-for="(item, index) in labelList" :key="index" :label="item.name" :value="item.label_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="gender">
          <el-radio label="男性"></el-radio>
          <el-radio label="女性"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="生日">
        <el-date-picker v-model="getdata.birthday" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="身高">
        <el-input class="max-w460" v-model="getdata.height"></el-input>
      </el-form-item>
      <el-form-item label="介绍">
        <el-input class="max-w460" v-model="getdata.introduce"></el-input>
      </el-form-item>
      <el-form-item label="昵称">
        <el-input class="max-w460" v-model="getdata.nickName"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input class="max-w460" v-model="getdata.mobile"></el-input>
      </el-form-item>
      <el-form-item label="工作时长">
        <el-input class="max-w460" v-model="getdata.working_hours"></el-input>
      </el-form-item>
      <el-form-item label="经度">
        <el-input class="max-w460" v-model="getdata.lng"></el-input>
      </el-form-item>
      <el-form-item label="纬度">
        <el-input class="max-w460" v-model="getdata.lat"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">修改技师</el-button>
      </el-form-item>
    </el-form>
    <!-- product_id -->
  </div>
</template>

<script>
// import  from
import Technician from "@/api/technician.js";
import HeadframeApi from "@/api/headframe.js";
export default {
  data() {
    return {
      waiter_user_id: "",
      getdata: [],
      gender: ""
    };
  },
  created() {
    this.waiter_user_id = this.$route.query.waiter_user_id;
    this.getData();
    this.getlabelData();
  },
  filters: {
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() > Date.now();
      },
      shortcuts: [
        {
          text: "今天",
          onClick(picker) {
            picker.$emit("pick", new Date());
          }
        },
        {
          text: "昨天",
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit("pick", date);
          }
        },
        {
          text: "一周前",
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", date);
          }
        }
      ]
    }
  },
  methods: {
    // 查询技师详情
    getData: function() {
      let self = this;
      Technician.getWaiterInfo(
        {
          waiter_user_id: self.waiter_user_id
        },
        true
      )
        .then(res => {
          // self.loading = false;
          self.getdata = res.data;
          self.gender = res.data.gender == 1 ? "男性" : "女性";
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 头衔
    getlabelData() {
      let self = this;
      HeadframeApi.labelDetail(
        {
          label_id: self.label_id
        },
        true
      )
        .then(res => {
          self.labelList = res.data.detail;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 修改技师
    onSubmit() {
      //
      let self = this;
      // let username
      let waiter_user_id = self.waiter_user_id;
      let username = self.getdata.username;
      let gender = self.getdata.gender;
      let birthday = self.getdata.birthday;
      let height = self.getdata.height;
      let introduce = self.getdata.introduce;
      let nickName = self.getdata.nickName;
      let mobile = self.getdata.mobile;
      let working_hours = self.getdata.working_hours;
      let lng = self.getdata.lng;
      let lat = self.getdata.lat;
      Technician.editWaiter(
        {
          username,
          gender,
          birthday,
          height,
          introduce,
          nickName,
          mobile,
          working_hours,
          lng,
          lat,
          waiter_user_id
        },
        true
      )
        .then(res => {
          if (res.code == 1) {
            self.$message(res.msg);
          }
          // self.loading = false;
          // self.getdata = res.data;
          //   self.gender = res.data.gender==1?'男性':'女性'
          //   console.log(self.gender)
          console.log(res);
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/technician/technician/edit.vue